// src/app/guards/super-admin.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { SuperAdminHelper } from '../helpers/super-admin.helper';
import {take} from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class SuperAdminGuard implements CanActivate {
	constructor(private superAdminHelper: SuperAdminHelper) {}

	canActivate(): Observable<boolean> {
		return this.superAdminHelper.canAccessSuperAdmin().pipe(take(1));
	}
}
